import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface ConfigFiltersState {
  hideLeaseOffers: boolean;
}

const initialState: ConfigFiltersState = {
  // TODO: This is a temporary change, until oADD dealers add the configuration in their AEM dealers pages.
  hideLeaseOffers: true,
};

const configFiltersSlice = createSlice({
  name: 'configFilters',
  initialState,
  reducers: {
    setHideLeaseOffers(state, action: PayloadAction<boolean>) {
      state.hideLeaseOffers = action.payload;
    },
  },
});

export const selectConfigFilters = (state: RootState) => state.configFilters;
export const { setHideLeaseOffers } = configFiltersSlice.actions;

export default configFiltersSlice.reducer;
